// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';

import store from '@/store';
import router from '@/router';
import VueProgressiveImage from 'vue-progressive-image';

import '@/assets/css/main.scss';

Vue.use(VueProgressiveImage);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<router-view />',
});



// WEBPACK FOOTER //
// ./src/main.js